import React, { useCallback, useRef } from 'react'
import { Box, IconButton } from '@mui/material'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import PrintIcon from '@mui/icons-material/Print'
import { exportChartPdf, printChart } from './chartExports'

export const ChartExportWrapper = ({
  title = 'Chart',
  children,
  actionsRightPadding,
  actionsTopPadding,
}: {
  title?: string
  children: React.ReactNode
  actionsRightPadding?: number
  actionsTopPadding?: number
}) => {
  const ref = useRef<HTMLDivElement>(null)

  const handlePdf = () => {
    if (ref.current) exportChartPdf(ref.current, title)
  }
  const handlePrint = () => {
    if (ref.current) printChart(ref.current, title)
  }

  return (
    <Box position="relative" sx={{ width: '100%' }}>
      <Box
        className="no-print"
        sx={{
          position: 'absolute',
          right: actionsRightPadding ? actionsRightPadding : 8,
          top: actionsTopPadding ? actionsTopPadding : -48,
          display: 'flex',
          gap: 0.5,
          bgcolor: 'rgba(255,255,255,0.8)',
          borderRadius: 1,
          p: '2px 6px',
          zIndex: 20,
        }}
      >
        <IconButton size="small" onClick={handlePrint}>
          <PrintIcon fontSize="inherit" />
        </IconButton>
        <IconButton size="small" onClick={handlePdf}>
          <PictureAsPdfIcon fontSize="inherit" />
        </IconButton>
      </Box>

      <Box ref={ref}>{children}</Box>
    </Box>
  )
}

import { forwardRef } from 'react'
